import React from 'react'

function SampleCollectionReoprtEntry() {
  return (
    <div>Sample Collection / Report Entry</div>
  )
}

export default SampleCollectionReoprtEntry